<template>
    <div class="container">


        <form  action="https://avilms.com/index.php"
              method="post" target="_blank">
            <div id="login-alert">
                <div class="alert alert-danger alert-dismissible fade show" role="alert"><strong>Invalid username and/or
                    password</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" fdprocessedid="ij80t">
                        <span aria-hidden="true">×</span></button>
                </div>
            </div>
            <div class="form-group">
                <label>
                    Username </label>
                <input type="text" name="username" id="username" v-model="form.username" class="form-control"
                       placeholder="Username" fdprocessedid="m4hbck">
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col">
                        <label>Password</label>
                    </div>
                    <div class="col-auto">
                        <a href="#" onclick="toggleForget()" class="form-text small text-muted">I forgot my
                            password.</a>
                    </div>
                </div>
                <div class="input-group input-group-merge">
                    <input type="password" v-model="form.password" name="password" id="password" autocomplete="off"
                           class="form-control form-control-appended" placeholder="Password" fdprocessedid="272qu">
                    <div class="input-group-append show-password">
                              <span class="input-group-text">
                                <i class="fe fe-eye"></i>
                              </span>
                    </div>
                </div>
            </div>
            <button type="submit" class="btn btn-lg btn-block btn-primary mb-3" onclick="checkLogin()" id="login-button"
                    fdprocessedid="i3dte6">Sign In
            </button>
        </form>


        <!--        <div>-->
        <!--            <div class="row mt-2" v-if="isKnownUser">-->
        <!--                <form id="login" name="login" action="https://avilms.com/index.php" method="post" target="_blank">-->
        <!--                    <input type="hidden" name="username" :value="flycoForm.username">-->
        <!--                    <input type="hidden" name="password" :value="flycoForm.password">-->
        <!--                    <button class="btn btn-primary btn-block small" type="submit" value="Login" id="btnflycologin"-->
        <!--                            ref="submitButton" style="width:100%;background-color:#56759c">-->
        <!--                        <span class="p-2" style="font-size: 20px;font-family: Helvetica, sans-serif;">Login Flyco</span>-->
        <!--                    </button>-->
        <!--                </form>-->
        <!--            </div>-->
        <!--            <div v-if="!isKnownUser" class="row mt-2">-->
        <!--                <div class="col-lg-4 col-md-2 col-1"></div>-->
        <!--                <div class="col-lg-4 col-md-8 col-10 shadow p-3 bg-body rounded">-->
        <!--                    <form @submit.prevent="" method="post" target="_blank">-->
        <!--                        <div style="text-align: center">-->
        <!--                          <h3 style="color: #56759c">Flyco | Login</h3>-->
        <!--                          <span style="color: #56759c;font-size: 14px;">(You only need to login once)</span>-->
        <!--                          <hr style="color: #a6abb1">-->
        <!--                        </div>-->
        <!--                        <div class="row" style="justify-content: center">-->
        <!--                          <div class="col-10 mb-3">-->
        <!--                              <input id="username" type="text" class="form-control" name="username" placeholder="Username"-->
        <!--                                     v-model="form.username" required autocomplete="off">-->
        <!--                          </div>-->
        <!--                          <div class="col-10 mb-3">-->
        <!--                              <input id="password" type="password" class="form-control" name="password"-->
        <!--                                     placeholder="Password"-->
        <!--                                     v-model="form.password" required autocomplete="off">-->
        <!--                            <div class="form-check mt-3">-->
        <!--                                <input name="rememberMe" class="form-check-input" type="checkbox" id="rememberMe"-->
        <!--                                       v-model="form.remember"/>-->
        <!--                                <label class="form-check-label" for="rememberMe" style="float: left"> Remember me-->
        <!--                                </label>-->
        <!--                            </div>-->
        <!--                          </div>-->
        <!--                          <div class="col-10">-->
        <!--                            <button class="btn btn-primary btn-block mb-4 mt-2 p-2" style="width:100%;background-color:#56759c" @click='tryLoginFlyco'>-->
        <!--                              <span class="p-2" style="font-size: 20px;font-family: Helvetica, sans-serif;">Login</span>-->
        <!--                            </button>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                    </form>-->
        <!--                </div>-->
        <!--                <div class="col-lg-4 col-md-2 col-1"></div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div>
            <CorendonLoading/>
        </div>
    </div>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import {loadingMixin} from "../../utils/mixins";
    import CorendonLoading from "../../components/ui/CorendonLoading";

    export default {
        name: "FlycoLogin",
        mixins: [loadingMixin],
        data() {
            return {
                rootFlyco: "",
                isKnownUser: false,
                form: {
                    id: 0
                    , userId: 0
                    , username: "rcapraz@corendon-airlines.com"
                    , password: "8c1.VEQ1dn"
                    , remember: true
                },
                flycoForm: {
                    username: "",
                    password: ""
                }
            }
        },
        components() {
            CorendonLoading
        },

        methods: {
            ...mapActions('flyco', ['getFlycoInfos', 'getFlycoInfo', 'AddFlycoInfo']),

            async FlycoUserInfo() {
                await this.getFlycoInfo(this.form.userId);
            },
            async checkFlycoUser() {
                try {

                    this.form.userId = this.user.userId;
                    await this.FlycoUserInfo();
                    console.log("this.flycoUserInfo");
                    console.log(this.flycoUserInfo);
                    if (this.flycoUserInfo.id != 0) {
                        this.isKnownUser = true;
                        this.flycoForm.username = this.flycoUserInfo.username
                        this.flycoForm.password = this.flycoUserInfo.password
                        await this.flycoRequestLogin();
                    }
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e.message});
                }
            },

            async tryLoginFlyco() {
                try {
                    this.form.userId = this.user.userId;
                    this.flycoForm.username = this.form.username,
                        this.flycoForm.password = this.form.password,
                        await this.AddFlycoInfo(this.form);
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e.message});
                } finally {
                    window.location.reload();
                }


            },

            async flycoRequestLogin() {
                try {
                    console.log("flycoReqest")
                    const form = await document.getElementById('login');
                    console.log(form)
                    const button = await document.getElementById('btnflycologin');
                    console.log(button)
                    this.$refs.submitButton.click();
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e.message});
                } finally {
                    this.$router.push({name: 'Dashboard'});
                }
            },
        },

        computed: {
            ...mapState('flyco', ['flycoUserInfo', 'flycoUserInfos']),
            ...mapState("auth", ["user"]),
        },

        async beforeMount() {
            // await this.checkFlycoUser();
        }

    }

</script>

<style scoped>
    .form-check-input:checked {
        background-color: #56759c;
    }
</style>
